/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './system-details.scss';

/* eslint-disable import/no-unresolved, import/default */

import systemDetailsTemplate from './system-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.systemDetails', [])
    .directive('agSystemDetails', SystemDetails)
    .name;

/*@ngInject*/
function SystemDetails() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SystemDetailsController,
        controllerAs: 'vm',
        templateUrl: systemDetailsTemplate
    };
}

/*@ngInject*/
function SystemDetailsController($scope, $log, $translate, agTypes, agUtils, types, siteService, userService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.system = null;

    vm.helpPageAction = agUtils.createHelpActionConfig("agSystem");

    vm.systemColor = systemColor;
    vm.systemStatusText = systemStatusText;

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;
            vm.ctx.widgetTitle = $translate.instant('ag.system.system') + '';
            loadSystem();
        }
    });

    $scope.$on('alarmsUpdated', function() {
        loadSystem();
    });

    function loadSystem() {
        vm.system = null;
        vm.loading = true;
        siteService.getSystem(true).then(
            (system) => {
                vm.system = system;
                vm.loading = false;
            },
            () => {
                vm.loading = false;
            }
        );
    }

    function systemColor() {
        if (vm.system && vm.system.highestAlarmSeverity === 'CRITICAL') {
            if (vm.system.highestAlarmStatus === types.alarmStatus.activeUnack) {
                return agTypes.colors.errorColor;
            }
            return agTypes.colors.normalGreyColor;
        } else {
            return agTypes.colors.normalColor;
        }
    }

    function systemStatusText() {
        if (vm.system && vm.system.highestAlarmSeverity === 'CRITICAL') {
            if (vm.system.highestAlarmStatus === types.alarmStatus.activeUnack) {
                return 'ag.system.status-alarms';
            }
            return 'ag.system.status-alarms-stale';
        } else {
            return 'ag.system.status-normal';
        }
    }
}